import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { usePresetContext } from "@/components/PresetProvider";
import { PAGE_CONFIGS } from "@/constants/PageType";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useRemoveAddIn } from "@/hooks/addins/useRemoveAddIn";
import { DataGridSettingsAddInData } from "@/models/DataGridSettingsAddInData";

export default function TableTemplates() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { username } = useGeotabClient();
  const { selectedPreset } = usePresetContext();
  const { saveGridState, loadSettings, templatePrefix, pageType } = useDataGridSettings();
  const { data = [] } = useAddinData<DataGridSettingsAddInData>(PAGE_CONFIGS[pageType].addInId);
  const removeAddIn = useRemoveAddIn(PAGE_CONFIGS[pageType].addInId, "id");
  const templates = data.filter(d => d.id.startsWith(templatePrefix + selectedPreset?.description));
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLoadTemplate = (template: DataGridSettingsAddInData) => {
    loadSettings(template);
    handleClose();
  };

  const handleDeleteTemplate = (template: string) => {
    removeAddIn.mutateAsync({ delSearch: template });
  };

  const handlePublish = () => {
    const name = prompt("Name: ");
    if (!name) return;
    const confirmation = confirm("Confirm new template " + name);
    if (!confirmation) return;
    saveGridState(templatePrefix + selectedPreset?.description + "-" + name);
  };

  const { t } = useTranslation();
  return (
    <>
      {templates?.length > 0 && (
        <>
          <Button size="small" onClick={handleClick} startIcon={<LibraryBooksIcon />}>
            {t("admin.templates")}
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {templates.map(template => (
              <MenuItem key={template.id} onClick={() => handleLoadTemplate(template)}>
                {username.endsWith("@fairfleet.de") && (
                  <DeleteIcon color="error" onClick={() => handleDeleteTemplate(template.id)} />
                )}
                {template.id.split("-")[2]}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
      {username.endsWith("@fairfleet.de") && (
        <Button size="small" onClick={handlePublish} startIcon={<CloudUploadIcon />}>
          {t("admin.publishTemplates")}
        </Button>
      )}
    </>
  );
}
